(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-print-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.dt-custom-print');

    sections.forEach((section) => {
      const navItems = Array.from(section.querySelectorAll('[data-custom-print-category]'));
      const cards = Array.from(section.querySelectorAll('[data-custom-print-card]'));
      const grid = section.querySelector('[data-custom-print-grid]');
      const empty = section.querySelector('[data-custom-print-empty]');
      const validCategories = new Set(navItems.map((item) => item.dataset.customPrintCategory));

      const setCategory = (category, updateUrl) => {
        const selectedCategory = validCategories.has(category) ? category : 'all';
        let visibleCount = 0;

        cards.forEach((card) => {
          const isVisible = selectedCategory === 'all' || card.dataset.category === selectedCategory;
          card.hidden = !isVisible;

          if (isVisible) {
            visibleCount += 1;
          }
        });

        navItems.forEach((item) => {
          const isActive = item.dataset.customPrintCategory === selectedCategory;
          item.classList.toggle('is-active', isActive);

          if (isActive) {
            item.setAttribute('aria-current', 'page');
          } else {
            item.removeAttribute('aria-current');
          }
        });

        if (empty) {
          empty.hidden = visibleCount > 0;
        }

        if (updateUrl) {
          const url = new URL(window.location.href);

          if (selectedCategory === 'all') {
            url.searchParams.delete('category');
          } else {
            url.searchParams.set('category', selectedCategory);
          }

          url.hash = 'custom-print-products';
          window.history.pushState({ customPrintCategory: selectedCategory }, '', url);
        }
      };

      navItems.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          setCategory(item.dataset.customPrintCategory, true);

          if (grid) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      window.addEventListener('popstate', () => {
        const params = new URLSearchParams(window.location.search);
        setCategory(params.get('category') || 'all', false);
      });

      const params = new URLSearchParams(window.location.search);
      setCategory(params.get('category') || 'all', false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-menu-link-fixes"]) return;
  try {
    
  (() => {
    const menuTargets = new Map([
      ['food packaging', '/collections/containers'],
      ['general supplies', '/collections/cleaning-supplies'],
      ['aluminum containers / foils', '/collections/aluminium'],
      ['aluminium containers / foils', '/collections/aluminium'],
      ['paper products', '/collections/paper-products'],
      ['wraps & films', '/collections/wraps-films'],
      ['containers', '/collections/containers'],
      ['insert fits', '/collections/insert-fits'],
      ['coffee lids', '/collections/black-dome-coffee-lid'],
      ['plates', '/collections/tableware'],
      ['beverage packaging', '/collections/beverage-packaging'],
      ['cutlery', '/collections/cutlery'],
      ['hygiene', '/collections/hygiene'],
      ['napkins', '/collections/napkins'],
      ['retail packaging', '/collections/retail-packaging'],
      ['catering supplies', '/collections/catering-supplies'],
      ['edible oils', '/collections/oil'],
    ]);

    const normalize = (text) => text.replace(/\s+/g, ' ').trim().toLowerCase();

    const repairHeaderLinks = () => {
      document.querySelectorAll('header-component a').forEach((link) => {
        const label = normalize(link.textContent || '');
        const target = menuTargets.get(label);

        if (!target) return;

        const href = link.getAttribute('href');
        if (href && href !== '#') return;

        link.setAttribute('href', target);
        link.dataset.dtMenuRepaired = 'true';
      });
    };

    repairHeaderLinks();

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('header-component a');
        if (!link) return;

        const target = menuTargets.get(normalize(link.textContent || ''));
        if (!target) return;

        const href = link.getAttribute('href');
        if (href && href !== '#') return;

        event.preventDefault();
        window.location.href = target;
      },
      true
    );

    document.addEventListener('DOMContentLoaded', repairHeaderLinks);
    document.addEventListener('shopify:section:load', repairHeaderLinks);

    const headerGroup = document.getElementById('header-group');
    if (headerGroup) {
      const observer = new MutationObserver(repairHeaderLinks);
      observer.observe(headerGroup, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-best-sellers').forEach((section) => {
    const scroller = section.querySelector('[data-featured-products-scroller]');
    const previousButton = section.querySelector('[data-featured-products-nav="previous"]');
    const nextButton = section.querySelector('[data-featured-products-nav="next"]');

    if (!scroller || !previousButton || !nextButton) {
      return;
    }

    const updateButtons = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      previousButton.disabled = scroller.scrollLeft <= 2;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 2;
    };

    const scrollCarousel = (direction) => {
      scroller.scrollBy({
        left: direction * Math.max(scroller.clientWidth * 0.9, 280),
        behavior: 'smooth',
      });
    };

    previousButton.addEventListener('click', () => scrollCarousel(-1));
    nextButton.addEventListener('click', () => scrollCarousel(1));
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();
})();
